// MT — utilidades compartidas por las secciones propias del tema.
(function () {
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-mt-delay') || '0', 10);
          setTimeout(function () { el.classList.add('mt-visible'); }, delay);
          observer.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initGalerias() {
    document.querySelectorAll('.mt-producto__galeria').forEach(function (galeria) {
      if (galeria.dataset.mtGaleriaInit) return;
      galeria.dataset.mtGaleriaInit = '1';
      var mainImg = galeria.querySelector('.mt-producto__principal img');
      var thumbs = galeria.querySelectorAll('[data-mt-thumb]');
      if (!mainImg) return;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          mainImg.src = btn.getAttribute('data-full');
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
  }

  function initColorSwatches() {
    document.querySelectorAll('[data-mt-color-swatch]').forEach(function (btn) {
      if (btn.dataset.mtColorInit) return;
      btn.dataset.mtColorInit = '1';
      btn.addEventListener('click', function () {
        var grupo = btn.closest('[data-mt-color-slot-group]');
        if (!grupo) return;
        grupo.querySelectorAll('[data-mt-color-swatch]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });
  }

  function construirItemsCarrito(form) {
    var activa = form.querySelector('.mt-oferta-carta.is-active');
    if (!activa) return null;
    var grupos = activa.querySelectorAll('[data-mt-color-slot-group]');
    if (!grupos.length) return null;
    var ofertasRoot = activa.closest('[data-mt-ofertas]');
    var sectionId = ofertasRoot ? ofertasRoot.getAttribute('data-mt-ofertas') : null;
    if (!sectionId) return null;
    var variantsEl = document.getElementById('mt-variantes-' + sectionId);
    if (!variantsEl) return null;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return null; }
    var conteo = {};
    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-oferta-carta__swatch.is-active');
      if (!activo) return;
      var valor = activo.getAttribute('data-mt-color-swatch');
      var variante = variants.find(function (v) { return v.option1 === valor; });
      if (!variante) return;
      conteo[variante.id] = (conteo[variante.id] || 0) + 1;
    });
    var ids = Object.keys(conteo);
    if (!ids.length) return null;
    return ids.map(function (id) { return { id: parseInt(id, 10), quantity: conteo[id] }; });
  }

  function initOfertas() {
    document.querySelectorAll('[data-mt-ofertas]').forEach(function (root) {
      if (root.dataset.mtOfertasInit) return;
      root.dataset.mtOfertasInit = '1';
      var sectionId = root.getAttribute('data-mt-ofertas');
      var descuento2 = parseFloat(root.getAttribute('data-mt-descuento-2') || '0');
      var descuento3 = parseFloat(root.getAttribute('data-mt-descuento-3') || '0');
      var cantidadInput = document.getElementById('mt-cantidad-real-' + sectionId);
      var precioActualEl = document.getElementById('mt-precio-actual-' + sectionId);
      var ahorroNotaEl = document.getElementById('mt-ahorro-nota-' + sectionId);
      var variantIdInput = document.getElementById('mt-variant-id-' + sectionId);
      var preciosEl = document.getElementById('mt-precios-' + sectionId);
      var botonTextoEl = document.getElementById('mt-boton-texto-' + sectionId);
      var btn = document.getElementById('mt-boton-comprar-' + sectionId);
      var precios = {};
      if (preciosEl) { try { precios = JSON.parse(preciosEl.textContent); } catch (e) {} }
      var cartas = root.querySelectorAll('.mt-oferta-carta');

      function formatMoney(valor) {
        var muestra = precioActualEl ? precioActualEl.textContent : '';
        var antes = /^[^\d]+/.exec(muestra);
        var despues = /[^\d]+$/.exec(muestra);
        var texto = valor.toFixed(2).replace('.', ',');
        if (antes) return antes[0] + texto;
        if (despues) return texto + despues[0];
        return texto;
      }

      function descuentoPara(cantidad) {
        if (cantidad === 2) return descuento2;
        if (cantidad === 3) return descuento3;
        return 0;
      }

      function precioUnidadActual() {
        var variantId = variantIdInput ? variantIdInput.value : null;
        var info = variantId ? precios[variantId] : null;
        return info ? parseFloat(info.price_raw) : null;
      }

      function actualizarPreciosCartas() {
        var precioUnidad = precioUnidadActual();
        if (precioUnidad === null) return;
        cartas.forEach(function (carta) {
          var cantidad = parseInt(carta.getAttribute('data-mt-oferta-cantidad'), 10);
          var out = carta.querySelector('[data-mt-oferta-precio]');
          if (!out) return;
          var descuento = descuentoPara(cantidad);
          out.textContent = formatMoney(precioUnidad * cantidad * (1 - descuento / 100));
        });
      }

      function seleccionar(cantidad) {
        cartas.forEach(function (c) {
          c.classList.toggle('is-active', parseInt(c.getAttribute('data-mt-oferta-cantidad'), 10) === cantidad);
        });
        if (cantidadInput) cantidadInput.value = cantidad;
        var precioUnidad = precioUnidadActual();
        var descuento = descuentoPara(cantidad);
        if (precioUnidad !== null && precioActualEl) {
          var totalSinDescuento = precioUnidad * cantidad;
          var total = totalSinDescuento * (1 - descuento / 100);
          precioActualEl.textContent = formatMoney(total);
        }
        if (ahorroNotaEl) {
          if (descuento > 0) {
            ahorroNotaEl.textContent = 'Ahorras ' + descuento + '%';
            ahorroNotaEl.style.display = '';
          } else {
            ahorroNotaEl.style.display = 'none';
          }
        }
        if (botonTextoEl && btn && !btn.disabled) {
          var base = btn.getAttribute('data-mt-texto-disponible') || 'Añadir al carrito';
          botonTextoEl.textContent = cantidad > 1 ? 'Añadir ' + cantidad + ' al carrito' : base;
        }
      }

      cartas.forEach(function (carta) {
        carta.addEventListener('click', function () {
          seleccionar(parseInt(carta.getAttribute('data-mt-oferta-cantidad'), 10));
        });
        carta.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          seleccionar(parseInt(carta.getAttribute('data-mt-oferta-cantidad'), 10));
        });
      });

      actualizarPreciosCartas();

      document.addEventListener('mt:variante-cambiada', function (e) {
        if (!e.detail || e.detail.sectionId !== sectionId) return;
        actualizarPreciosCartas();
        var activa = root.querySelector('.mt-oferta-carta.is-active');
        seleccionar(activa ? parseInt(activa.getAttribute('data-mt-oferta-cantidad'), 10) : 1);
      });
    });
  }

  function initCantidadSimple() {
    document.querySelectorAll('input[id^="mt-cantidad-"]').forEach(function (input) {
      if (input.id.indexOf('mt-cantidad-real-') === 0 || input.dataset.mtCantidadInit) return;
      input.dataset.mtCantidadInit = '1';
      var sectionId = input.id.replace('mt-cantidad-', '');
      var real = document.getElementById('mt-cantidad-real-' + sectionId);
      if (!real) return;
      input.addEventListener('input', function () {
        var v = parseInt(input.value, 10);
        real.value = v > 0 ? v : 1;
      });
    });
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initParallax() {
    var secciones = document.querySelectorAll('[data-mt-parallax]');
    if (!secciones.length || reduceMotion) return;
    var ticking = false;

    function actualizar() {
      secciones.forEach(function (sec) {
        var img = sec.querySelector('[data-mt-parallax-img]');
        if (!img) return;
        var rect = sec.getBoundingClientRect();
        var centro = rect.top + rect.height / 2 - window.innerHeight / 2;
        var desplazamiento = Math.max(-40, Math.min(40, centro * -0.06));
        img.style.transform = 'translateY(' + desplazamiento + 'px) scale(1.12)';
      });
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(actualizar);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    actualizar();
  }

  function initTilt() {
    if (reduceMotion || matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('.mt-beneficio').forEach(function (card) {
      if (card.dataset.mtTiltInit) return;
      card.dataset.mtTiltInit = '1';
      card.addEventListener('pointermove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'perspective(800px) rotateX(' + (y * -8) + 'deg) rotateY(' + (x * 8) + 'deg) translateY(-6px)';
      });
      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
      });
    });
  }

  function animarCifra(el) {
    var texto = el.textContent.trim();
    var match = texto.match(/^(\d+(?:[.,]\d+)?)(.*)$/);
    if (!match) return;
    var destino = parseFloat(match[1].replace(',', '.'));
    var decimales = (match[1].split(/[.,]/)[1] || '').length;
    var resto = match[2];
    if (reduceMotion) return;
    var inicio = null;
    var duracion = 1100;
    function paso(ts) {
      if (!inicio) inicio = ts;
      var progreso = Math.min(1, (ts - inicio) / duracion);
      var facil = 1 - Math.pow(1 - progreso, 3);
      var valor = destino * facil;
      el.textContent = valor.toFixed(decimales) + resto;
      if (progreso < 1) window.requestAnimationFrame(paso);
    }
    window.requestAnimationFrame(paso);
  }

  function initContadores() {
    var els = document.querySelectorAll('.mt-cifra__num:not([data-mt-contado])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-mt-contado', '1');
          animarCifra(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initUsos() {
    document.querySelectorAll('[data-mt-usos]').forEach(function (root) {
      if (root.dataset.mtInit) return;
      root.dataset.mtInit = '1';
      var tabs = root.querySelectorAll('[data-mt-uso-tab]');
      var paneles = root.querySelectorAll('[data-mt-uso-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var indice = tab.getAttribute('data-mt-uso-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          paneles.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-mt-uso-panel') === indice);
          });
        });
      });
    });
  }

  function initAnclas() {
    document.querySelectorAll('a[href^="#"]').forEach(function (enlace) {
      if (enlace.dataset.mtAnclaInit) return;
      enlace.dataset.mtAnclaInit = '1';
      var frag = enlace.getAttribute('href').slice(1);
      if (!frag) return;
      enlace.addEventListener('click', function (e) {
        var destino = document.getElementById(frag) || document.querySelector('[id$="__' + frag + '"]');
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initBadgeFlotante() {
    document.querySelectorAll('.mt-badge-flotante').forEach(function (badge) {
      if (badge.dataset.mtInit) return;
      badge.dataset.mtInit = '1';
      badge.addEventListener('click', function () {
        var selector = badge.getAttribute('data-mt-scroll-a');
        var destino = selector && document.querySelector(selector);
        if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initStickyBar() {
    document.querySelectorAll('[data-mt-sticky-bar]').forEach(function (barra) {
      if (barra.dataset.mtInit) return;
      barra.dataset.mtInit = '1';

      var objetivoId = barra.getAttribute('data-mt-observa');
      var objetivo = objetivoId && document.getElementById(objetivoId);
      if (objetivo && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              barra.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
            });
          },
          { threshold: 0 }
        );
        observer.observe(objetivo);
      }

      var botonSubmit = barra.querySelector('[data-mt-sticky-submit]');
      if (botonSubmit) {
        botonSubmit.addEventListener('click', function () {
          var formId = botonSubmit.getAttribute('data-mt-sticky-submit');
          var form = document.getElementById(formId);
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }

      var precioSticky = barra.querySelector('[data-mt-sticky-precio]');
      var precioOrigen = document.querySelector('[id^="mt-precio-actual-"]');
      if (precioSticky && precioOrigen && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () {
          precioSticky.textContent = precioOrigen.textContent;
        });
        mo.observe(precioOrigen, { childList: true, characterData: true, subtree: true });
      }
    });
  }

  function mostrarToast(mensaje, tipo) {
    var existente = document.querySelector('.mt-toast');
    if (existente) existente.remove();
    var toast = document.createElement('div');
    toast.className = 'mt-toast' + (tipo === 'error' ? ' mt-toast--error' : '');
    toast.innerHTML =
      '<span class="mt-toast__texto"></span>' +
      (tipo === 'error' ? '' : '<a href="/cart" class="mt-toast__enlace">Ver carrito</a>');
    toast.querySelector('.mt-toast__texto').textContent = mensaje;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 350);
    }, 3800);
  }

  function actualizarIconoCarrito() {
    var icono = document.getElementById('cart-icon-bubble');
    if (!icono) return;
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        if (!html) return;
        icono.innerHTML = html;
      })
      .catch(function () {});
  }

  function initFormularioAjax() {
    document.querySelectorAll('form[id="mt-form-producto"]').forEach(function (form) {
      if (form.dataset.mtAjaxInit) return;
      form.dataset.mtAjaxInit = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var botones = form.querySelectorAll('button[type="submit"]');
        var stickyBoton = document.querySelector('[data-mt-sticky-submit]');
        var todos = Array.from(botones).concat(stickyBoton ? [stickyBoton] : []);
        todos.forEach(function (b) { b.disabled = true; });

        var items = construirItemsCarrito(form);
        var cuerpo = items ? { items: items } : Object.fromEntries(new FormData(form).entries());

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(cuerpo),
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (resultado) {
            if (!resultado.ok) {
              mostrarToast(resultado.data.description || 'No se ha podido añadir al carrito.', 'error');
              return;
            }
            mostrarToast('Añadido al carrito');
            actualizarIconoCarrito();
          })
          .catch(function () {
            mostrarToast('No se ha podido añadir al carrito. Inténtalo de nuevo.', 'error');
          })
          .finally(function () {
            todos.forEach(function (b) { b.disabled = false; });
          });
      });
    });
  }

  function initComparador() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (contenedor) {
      if (contenedor.dataset.mtInit) return;
      contenedor.dataset.mtInit = '1';

      var antes = contenedor.querySelector('[data-mt-comparador-antes]');
      var manija = contenedor.querySelector('[data-mt-comparador-manija]');
      var arrastrando = false;

      function fijarPorcentaje(pct) {
        pct = Math.max(0, Math.min(100, pct));
        antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        manija.style.left = pct + '%';
        manija.setAttribute('aria-valuenow', Math.round(pct));
      }

      function porcentajeDesdeEvento(clientX) {
        var rect = contenedor.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      contenedor.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        contenedor.setPointerCapture(e.pointerId);
        fijarPorcentaje(porcentajeDesdeEvento(e.clientX));
      });
      contenedor.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        fijarPorcentaje(porcentajeDesdeEvento(e.clientX));
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
        contenedor.addEventListener(evt, function () { arrastrando = false; });
      });

      manija.addEventListener('keydown', function (e) {
        var actual = parseFloat(manija.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft') { fijarPorcentaje(actual - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { fijarPorcentaje(actual + 5); e.preventDefault(); }
      });

      fijarPorcentaje(50);
    });
  }

  function initTodo() {
    initReveals();
    initGalerias();
    initColorSwatches();
    initOfertas();
    initCantidadSimple();
    initUsos();
    initAnclas();
    initBadgeFlotante();
    initStickyBar();
    initFormularioAjax();
    initComparador();
    initParallax();
    initTilt();
    initContadores();
  }

  document.addEventListener('DOMContentLoaded', initTodo);

  // Las secciones se re-renderizan al editar en el editor de temas: vuelve a
  // observar/inicializar los elementos nuevos de esa sección.
  document.addEventListener('shopify:section:load', initTodo);
})();
